import { Injectable } from '@angular/core';

import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SiteService } from '../services/context-discovery/site.service';
import { OrganisationSettingsService } from '../services/organisation-settings.service';
import { CdtStatus } from '../../cdt-status';
import { EventBusService } from '../services/shared/event-bus.service';

@Injectable()
export class FslGuard implements CanActivate {
    organisationId = null;
    routeToNavigate: any;

    constructor(
        private siteService: SiteService,
        private organisationSettingsService: OrganisationSettingsService,
        private eventBus: EventBusService,
        private router: Router
    ) {
        this.organisationId = sessionStorage.getItem('organizationid');
    }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        if (_route.queryParams && !!_route.queryParams.section) {
            this.routeToNavigate = _route.queryParams.section;
            this.siteService.getModelCreatedStatus(this.organisationId).subscribe(
                this.getModelCreatedStatusUnifiedWorkflowSuccessCallBack.bind(this),
                this.getModelCreatedStatusFailureCallBack.bind(this)
            );
        } else {
            this.siteService.getModelCreatedStatus(this.organisationId).subscribe(
                this.getModelCreatedStatusSuccessCallBack.bind(this),
                this.getModelCreatedStatusFailureCallBack.bind(this));
        }
        return false;
    }

    getModelCreatedStatusUnifiedWorkflowSuccessCallBack(response) {
        if (response && response.isModelPresent) {
            this.router.navigate([this.routeToNavigate]);
        } else {
            this.eventBus.conveyToNavigate('/model-error');
        }
    }

    getModelCreatedStatusSuccessCallBack(response) {
        if (response && response.isModelPresent) {
            this.siteService.getStatusFromOrganizationIdWithCache(this.organisationId).subscribe(statusResponse => {
                if (statusResponse && (statusResponse.Status === CdtStatus.IN_PROGRESS
                    || statusResponse.Status === CdtStatus.PUBLISH_IN_PROGRESS
                    || statusResponse.Status === CdtStatus.PUBLISH_FAILED)) {
                    this.eventBus.conveyToNavigate('/identify-assets');
                } else if (statusResponse && (statusResponse.Status === CdtStatus.FAILED)) {
                    this.eventBus.conveyToNavigate('/upload');
                } else {
                    this.organisationSettingsService.setOrganisationId(this.organisationId);
                    this.organisationSettingsService.getSettings().subscribe(settings => {
                        if (settings.PreSales && settings.PreSales.CdtStatus === 'Triggered') {
                            this.eventBus.conveyToNavigate('/identify-assets');
                        } else {
                            this.eventBus.conveyToNavigate('/upload');
                        }
                    }, _ => {
                        this.eventBus.conveyToNavigate('/upload');
                    });
                }
            }, _ => {
                this.eventBus.conveyToNavigate('/upload');
            });
        } else {
            this.eventBus.conveyToNavigate('/model-error');
        }
    }

    getModelCreatedStatusFailureCallBack() {
        this.eventBus.conveyToNavigate('/error');
    }
}
